import React, { useEffect } from 'react'
import { useStoreState, useStoreActions } from 'easy-peasy'
import { getParam } from '../../helpers'

export default function InputHidden({ name, param }) {
  const value = getParam(param)
  const [input] = useStoreState(state => [state.form.getByName(name)])
  const [setInputValue] = useStoreActions(actions => [
    actions.form.setInputValue,
  ])

  useEffect(() => {
    setInputValue({ name, value })
  }, [name, setInputValue, value])

  return (
    <input
      type="hidden"
      id={`hidden-${name}`}
      name={name}
      value={value}
    />
  )
}
